<template>
  <div class="review-page">
    <div class="content-wrap" ref="contentBScrollWrap">
      <div class="container">
        <div class="banner">
          <div class="progress">
            <img src="../../assets/progress-1.png" />
            <div class="items">
              <div class="item">录入身份证</div>
              <div class="item">填写个人信息</div>
              <div class="item">预约成功</div>
            </div>
          </div>
          <div class="title">
            <p class="title1">请确认您的信息</p>
            <p class="title2">
              核实您的姓名、身份证号、发证机关、有效期开始日期和有效期截止日期
            </p>
          </div>
        </div>
        <div class="info-box">
          <div class="certificate-box">
            <div class="input-box">
              <p class="name">姓名</p>
              <div class="right">
                <input
                  class="info-input nmr"
                  v-model="formData.name"
                  placeholder="请输入"
                />
              </div>
            </div>
            <div class="input-box">
              <p class="name">身份证号</p>
              <div class="right">
                <input
                  class="info-input nmr"
                  v-model="formData.identificationNumber"
                  placeholder="请输入"
                />
              </div>
            </div>
            <div class="input-box">
              <p class="name">发证机关</p>
              <div class="right">
                <input
                  class="info-input nmr"
                  placeholder="请输入"
                  v-model="formData.identificationOffice"
                />
              </div>
            </div>
            <div class="input-box">
              <p class="name">有效期开始日期</p>
              <div class="right" @click="toShowBeginDatePicker">
                <p
                  :class="[
                    'info',
                    { unchoose: !formData.identificationBeginning }
                  ]"
                >
                  {{ formData.identificationBeginning || '请选择' }}
                </p>
                <div class="more"></div>
              </div>
            </div>
            <div class="input-box">
              <p class="name">有效期截止日期</p>
              <div class="right" @click="toShowEndDatePicker">
                <p
                  :class="[
                    'info',
                    { unchoose: !formData.identificationEnding }
                  ]"
                >
                  {{ formData.identificationEnding || '请选择' }}
                </p>
                <div class="more"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn_box">
          <!-- <button @click="$router.go(-1)">返回</button> -->
          <button @click="toSure">下一步</button>
        </div>
        <Popup
          v-model="showBeginningDatePicker"
          :close-on-click-overlay="false"
          position="bottom"
          :style="{
            height: '40%',
            borderTopLeftRadius: '15px',
            borderTopRightRadius: '15px'
          }"
        >
          <DatetimePicker
            :max-date="maxDate"
            :minDate="minDate"
            v-model="currentBeginDate"
            type="date"
            @confirm="confirmBeginningDate"
            @cancel="closeDatePicker(1)"
          />
        </Popup>
        <Popup
          v-model="showEndingDatePicker"
          :close-on-click-overlay="false"
          position="bottom"
          :style="{
            height: '40%',
            borderTopLeftRadius: '15px',
            borderTopRightRadius: '15px'
          }"
        >
          <DatetimePicker
            :max-date="maxDate"
            :minDate="minDate"
            v-model="currentEndDate"
            type="date"
            @confirm="confirmEndingDate"
            @cancel="closeDatePicker(2)"
          />
        </Popup>
      </div>
    </div>
  </div>
</template>

<script>
import { DatetimePicker, Popup, Toast } from 'vant'
import moment from 'moment'
import { mapState, mapMutations } from 'vuex'
const format = 'YYYY-MM-DD'
export default {
  data() {
    return {
      formData: {
        name: '',
        identificationNumber: '',
        identificationOffice: '',
        identificationBeginning: '',
        identificationEnding: ''
      },
      currentBeginDate: new Date(),
      currentEndDate: new Date(),
      maxDate: new Date(2099, 12, 31),
      minDate: new Date(2000, 1, 1),
      showBeginningDatePicker: false,
      showEndingDatePicker: false
    }
  },
  components: {
    DatetimePicker,
    Popup
  },
  computed: {
    ...mapState('globalData', ['idInfo'])
  },
  mounted() {
    if (this.idInfo && this.idInfo.userName) {
      this.formData.name = this.idInfo.userName
      this.formData.identificationNumber = this.idInfo.idNo
      this.formData.identificationOffice = this.idInfo.issuingAuthority
      this.formData.identificationBeginning = moment(
        this.idInfo.certOriginDate
      ).format(format)
      this.currentBeginDate = new Date(this.formData.identificationBeginning)
      this.formData.identificationEnding = moment(
        this.idInfo.certExpiryDate
      ).format(format)
      // console.log(11111, moment('20200102').format(format))
      this.currentEndDate = new Date(this.formData.identificationEnding)
    }
  },
  methods: {
    ...mapMutations('globalData', ['setIdInfo']),
    async toSure() {
      if (
        this.formData.name &&
        this.formData.identificationNumber &&
        this.formData.identificationOffice &&
        this.formData.identificationBeginning &&
        this.formData.identificationEnding
      ) {
        try {
          Toast.loading({ message: '加载中', duration: null })
          const { data } = await this.$fetch.post('/appointment/check', {
            userName: this.formData.name,
            idNo: this.formData.identificationNumber
          })
          Toast.clear(true)
          if (data.status === 200) {
            this.setIdInfo(this.formData)
            this.$router.replace('form')
          } else {
            this.$dialog
              .alert({
                title: '系統提示',
                message: data.message,
                confirmButtonColor: '#1669ff'
              })
              .then(() => {})
              .catch(() => {})
          }
        } catch (error) {
          Toast.clear(true)
          Toast.fail({ message: error.response.data.message })
          // console.log(error)
        }
      } else {
        Toast('请完善所有数据')
      }
    },
    confirmBeginningDate(value, index) {
      this.formData.identificationBeginning = moment(value).format(format)
      this.showBeginningDatePicker = false
    },
    confirmEndingDate(value, index) {
      this.formData.identificationEnding = moment(value).format(format)
      this.showEndingDatePicker = false
    },
    toShowBeginDatePicker() {
      this.showBeginningDatePicker = true
    },
    toShowEndDatePicker() {
      this.showEndingDatePicker = true
    },
    closeDatePicker(val) {
      switch (val) {
        case 1:
          this.showBeginningDatePicker = false
          this.currentBeginDate = new Date(
            this.formData.identificationBeginning
          )
          break
        case 2:
          this.showEndingDatePicker = false
          this.currentEndDate = new Date(this.formData.identificationEnding)
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.review-page {
  height: 100vh;
  background-color: #f8f8f8;
}
.container {
  height: auto;
  min-height: 100vh;
  width: 750px;
  background-color: #f8f8f8;
  padding-bottom: 100px;
  background: url('../../assets/bg-1.png') no-repeat;
  background-size: 100%;
  padding-top: 22px;
  .banner {
    .progress {
      width: 616px;
      margin: 0 auto;
      .items {
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        font-size: 24px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.56);
        .item {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          &:first-child {
            justify-content: flex-start;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
          }
          &:last-child {
            justify-content: flex-end;
          }
        }
      }
    }
    .title {
      width: 624px;
      margin: 0 auto;
      margin-top: 60px;
      .title1 {
        font-size: 36px;
        color: #ffffff;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 500;
      }
      .title2 {
        font-size: 24px;
        color: #ffffff;
        font-family: PingFang SC-Medium, PingFang SC;
        opacity: 0.7;
        margin-top: 16px;
      }
    }
  }
  .info-box {
    width: 673px;
    height: 700px;
    margin: auto;
    background: #ffffff;
    box-shadow: 0px 2px 8px 1px rgba(167, 167, 167, 0.2);
    border-radius: 22px 22px 22px 22px;
    .certificate-box {
      border-radius: 22px 22px 22px 22px;
      width: 100%;
      background-color: #fff;
      height: auto;
      padding-left: 30px;
      padding-right: 30px;
      margin-top: 50px;
      padding-top: 24px;
      .input-box {
        height: 88px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 24px 0 24px 0;
        padding: 0 40px 0 40px;
        background: #f4f9ff;
        border-radius: 100px 100px 100px 100px;
        .name {
          font-size: 30px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(67, 76, 99, 0.7);
          height: 30px;
          line-height: 1;
        }
        .right {
          width: auto;
          height: 100%;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .info {
            width: auto;
            height: 30px;
            line-height: 1.1;
            font-size: 30px;
            margin-right: 30px;
            color: #1a1a1a;
          }
          .info-input {
            width: 370px;
            height: 42px;
            font-size: 30px;
            margin-right: 30px;
            color: #1a1a1a;
            background-color: #f4f9ff;
          }
          .address {
            width: 500px;
            height: auto;
            font-size: 30px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #1a1a1a;
            text-align: right;
          }
          .nmr {
            margin-right: 0;
            text-align: right;
          }
          .unchoose {
            color: #9199bd;
          }
          .more {
            width: 10px;
            height: 18px;
            background: url('../../assets/more.png') no-repeat;
            background-size: 100%;
          }
          input {
            width: 500px;
            height: 42px;
            font-size: 30px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #1a1a1a;
            &::-webkit-input-placeholder {
              color: #cccccc;
              font-size: 29px;
            }
            &:-moz-placeholder {
              color: #cccccc;
              font-size: 29px;
            }
            &::-moz-placeholder {
              color: #cccccc;
              font-size: 29px;
            }
            &:-ms-input-placeholder {
              color: #cccccc;
              font-size: 29px;
            }
          }
          .clear-btn {
            position: absolute;
            right: 40px;
            top: 8px;
            width: 30px;
            height: 30px;
            display: block;
          }
          .get-code {
            position: absolute;
            right: 28px;
            width: 170px;
            height: 60px;
            background: #ffffff;
            border: 1px solid #4b63a6;
            border-radius: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 28px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #444c68;
          }
        }
      }
      .no-border {
        border-bottom: none;
      }
      .img-box {
        height: 152px;
      }
    }
  }
  .btn_box {
    width: 750px;
    position: fixed;
    bottom: 114px;
    left: 0;
    padding: 0 30px 0 30px;
    margin-top: 108px;
    button {
      border: none;
      width: 100%;
      height: 96px;
      background: #1669ff;
      border-radius: 128px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
</style>
